import(/* webpackMode: "eager" */ "/vercel/path0/app/glossary/page.tsx");
